import * as Yup from "yup";

const isValidObjectWithId = (value) =>
  value &&
  typeof value === "object" &&
  (typeof value.id === "string" || typeof value.id === "number") &&
  value.id !== "";

// Validador específico para el customerId (cliente receptor)
const isValidCustomer = (value) =>
  value &&
  typeof value === "object" &&
  (typeof value.id === "string" || typeof value.id === "number") &&
  value.id !== "" &&
  typeof value.name === "string" &&
  value.name.trim() !== "";

export function getInvoiceSchema() {
  return Yup.object().shape({
    fiscalRegimeId: Yup.mixed()
      .test(
        "fiscalRegimeId",
        "El régimen fiscal es requerido",
        isValidObjectWithId
      )
      .required("El régimen fiscal es requerido"),

    paymentFormId: Yup.mixed()
      .test(
        "paymentFormId",
        "La forma de pago es requerida",
        isValidObjectWithId
      )
      .required("La forma de pago es requerida"),

    paymentMethodId: Yup.mixed()
      .test(
        "paymentMethodId",
        "El método de pago es requerido",
        isValidObjectWithId
      )
      .required("El método de pago es requerido"),

    customerId: Yup.mixed()
      .test("customerId", "El receptor (cliente) es requerido", isValidCustomer)
      .required("El receptor (cliente) es requerido"),

    cfdiId: Yup.mixed()
      .test("cfdiId", "El uso de CFDI es requerido", isValidObjectWithId)
      .required("El uso de CFDI es requerido"),

    conceptoFactura: Yup.string()
      .trim()
      .required("El concepto de la factura es requerido")
      .min(3, "El concepto debe tener al menos 3 caracteres"),

    fecha: Yup.date()
      .required("La fecha es requerida")
      .typeError("La fecha no es válida"),

    folio: Yup.string().required("El folio es requerido"),

    serie: Yup.string().required("La serie es requerida"),

    conceptosFacturaTabla: Yup.array()
      .of(
        Yup.object().shape({
          cantidad: Yup.number()
            .required("La cantidad es requerida")
            .typeError("La cantidad debe ser un número")
            .moreThan(0, "La cantidad debe ser mayor a 0"),

          productKey: Yup.mixed()
            .test(
              "productKey",
              "La clave del producto es requerida",
              isValidObjectWithId
            )
            .required("La clave del producto es requerida"),

          unitKey: Yup.mixed()
            .test("unitKey", "La unidad es requerida", isValidObjectWithId)
            .required("La unidad es requerida"),

          precioUnitario: Yup.number()
            .required("El precio unitario es requerido")
            .typeError("El precio unitario debe ser un número")
            .moreThan(0, "El precio unitario debe ser mayor a 0"),

          iva: Yup.number()
            .typeError("El IVA debe ser un número")
            .min(0, "El IVA no puede ser negativo"),

          total: Yup.number()
            .required("El total es requerido")
            .typeError("El total debe ser un número")
            .moreThan(0, "El total debe ser mayor a 0"),

          needRetention: Yup.boolean(),

        })
      )
      .min(1, "Debes agregar al menos un concepto a la factura"),
  });
}
